import {Injectable} from '@angular/core';
import {DcpApiService} from '@dcp/configurator';
import {map} from 'rxjs/operators';
import {BehaviorSubject, combineLatest, Observable, Subject} from 'rxjs';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {User} from '@spartacus/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

export interface RestrictedAddTechContactCreation {
  restrictedAddTechContactCreation: {
    individual: boolean;
    organization: boolean;
  };
}

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class RestrictedAddTechContactCreationService {
  private restrictionSubject: Subject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private dcpApiService: DcpApiService,
    private userFacade: UserAccountFacade,
  ) {
    combineLatest([
      this.userFacade.get(),
      this.dcpApiService.callKyma<any>('config', 'restrictedAddTechContactCreation'),
    ]).pipe(
      map(([user, {restrictedAddTechContactCreation}]: [User, RestrictedAddTechContactCreation]) =>
        !restrictedAddTechContactCreation[user?.companyType]),
    ).pipe(untilDestroyed(this)).subscribe((isEnabled) => {
      this.restrictionSubject.next(isEnabled);
    });
  }

  get(): Observable<boolean | undefined> {
    return this.restrictionSubject.asObservable();
  }
}
